(() => {
  function bindTrackpadScroll(sliderEl, swiper) {
    let locked = false;
    let unlockTimer = null;

    sliderEl.addEventListener(
      'wheel',
      function (event) {
        const deltaX = event.deltaX;
        const deltaY = event.deltaY;
        const isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);

        if (!isHorizontal || Math.abs(deltaX) < 10) return;
        if (locked || swiper.animating) {
          event.preventDefault();
          return;
        }

        const goingNext = deltaX > 0;
        const atStart = swiper.isBeginning;
        const atEnd = swiper.isEnd;

        if ((goingNext && atEnd) || (!goingNext && atStart)) return;

        event.preventDefault();
        locked = true;

        if (goingNext) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }

        clearTimeout(unlockTimer);
        unlockTimer = setTimeout(function () {
          locked = false;
        }, 450);
      },
      { passive: false }
    );
  }

  function createSlider(sliderEl) {
    if (sliderEl.dataset.simpleRoutineInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return false;

    const sectionRoot = sliderEl.closest('.simple-routine') || document;
    const paginationEl = sectionRoot.querySelector('.simple-routine__pagination');
    const nextEl = sectionRoot.querySelector('.simple-routine__nav--next');
    const prevEl = sectionRoot.querySelector('.simple-routine__nav--prev');
    const gapDesktop = Number(sliderEl.dataset.gapDesktop) || 20;
    const gapMobile = Number(sliderEl.dataset.gapMobile) || 16;
    const desktopLayout = sliderEl.dataset.desktopLayout || 'row';
    const desktopIsSlider = desktopLayout === 'slider';

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: gapMobile,
      watchOverflow: true,
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      touchRatio: 1,
      threshold: 5,
      resistanceRatio: 0.85,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : undefined,
      navigation:
        nextEl && prevEl
          ? {
              nextEl: nextEl,
              prevEl: prevEl
            }
          : undefined,
      breakpoints: {
        990: desktopIsSlider
          ? {
              slidesPerView: 3,
              spaceBetween: gapDesktop
            }
          : {
              enabled: false
            }
      }
    });

    if (desktopIsSlider) {
      bindTrackpadScroll(sliderEl, swiper);
    }

    sliderEl.dataset.simpleRoutineInitialized = 'true';
    return true;
  }

  function initSimpleRoutineSliders(scope) {
    const root = scope || document;
    const sliders = root.querySelectorAll('.simple-routine__swiper');
    let pending = false;

    sliders.forEach((sliderEl) => {
      if (!createSlider(sliderEl)) {
        pending = true;
      }
    });

    if (pending && typeof Swiper === 'undefined') {
      window.addEventListener(
        'load',
        function () {
          initSimpleRoutineSliders(root);
        },
        { once: true }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSimpleRoutineSliders(document);
    });
  } else {
    initSimpleRoutineSliders(document);
  }

  document.addEventListener('bundle:after-switch', function () {
    initSimpleRoutineSliders(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSimpleRoutineSliders(event && event.target ? event.target : document);
  });
})();
